import { takeLatest } from 'redux-saga'
import { put, call, select, all } from 'redux-saga/effects'

import callAny from './helpers/call_any'
import actionTypes from 'redux/actions/actionTypes'
import onboardingGuideActions from 'redux/actions/onboardingGuideActions'
import { onboardingGuideSync } from 'sync'
import formatError from './helpers/error_formatter'
import launchLiveLessonHelper from './helpers/launch_live_lesson'
import onboardingGuideCardTypes from 'helpers/enums/onboardingGuideCardTypes'
import onboardingGuideCardStatusTypes from 'helpers/enums/onboardingGuideCardStatusTypes'
import onboardingGuideLaunchTourCardSelector from 'redux/selectors/onboarding_guide/cards/onboarding_guide_launch_tour_selector'
import onboardingGuideExploreLessonsSelector from 'redux/selectors/onboarding_guide/cards/onboarding_guide_explore_lessons_selector'
import onboardingGuideLessonBuilderSelector from 'redux/selectors/onboarding_guide/cards/onboarding_guide_lesson_builder_selector'
import onboardingGuideSessionPreviewSelector from 'redux/selectors/onboarding_guide/cards/onboarding_guide_session_preview_selector'

function *getOnboardingGuideData() {
	try {
		const response = yield callAny(onboardingGuideSync.getOnboardingGuideData)
		yield put(onboardingGuideActions.fetched(response.payload))
	} catch (error) {
		const serverError = formatError(error)
		yield put(onboardingGuideActions.failed(serverError))
	}
}

function *completeLaunchTourCard() {
	try {
		const card = yield select(onboardingGuideLaunchTourCardSelector)
		if (card.status === onboardingGuideCardStatusTypes.PENDING) {
			yield callAny(onboardingGuideSync.completeCard, onboardingGuideCardTypes.LAUNCH_TOUR)
		}
		yield put(onboardingGuideActions.launchTourCardSuccess())
	} catch (error) {
		// console.log(error)
	}
}

function *completeExploreLessonsCard() {
	try {
		const card = yield select(onboardingGuideExploreLessonsSelector)
		if (card.status === onboardingGuideCardStatusTypes.PENDING) {
			yield callAny(onboardingGuideSync.completeCard, onboardingGuideCardTypes.EXPLORE_LESSONS)
		}
	} catch (error) {
		// console.log(error)
	}
}

function *completeLessonBuilderCard() {
	try {
		const card = yield select(onboardingGuideLessonBuilderSelector)
		if (card.status === onboardingGuideCardStatusTypes.PENDING) {
			yield callAny(onboardingGuideSync.completeCard, onboardingGuideCardTypes.LESSON_BUILDER)
		}
		yield put(onboardingGuideActions.createLessonSuccess())
	} catch (error) {
		// console.log(error)
	}
}

function *enableOnboardingGuide() {
	try {
		const response = yield callAny(onboardingGuideSync.toggleOnboardingGuideActivation)
		yield put(onboardingGuideActions.enabled(response.payload))
	} catch (error) {
		const serverError = formatError(error)
		yield put(onboardingGuideActions.failed(serverError))
	}
}

function *dismissOnboardingGuide() {
	try {
		yield callAny(onboardingGuideSync.toggleOnboardingGuideActivation)
	} catch (error) {
		// console.log(error)
	}
}

function *launchSessionPreview(action) {
	try {
		const isNew = false
		const launchSessionPreview = [
			call(launchLiveLessonHelper, action.presentation_uid, isNew),
		]
		const card = yield select(onboardingGuideSessionPreviewSelector)
		if (card.status === onboardingGuideCardStatusTypes.PENDING) {
			launchSessionPreview.push(
				callAny(onboardingGuideSync.completeCard, onboardingGuideCardTypes.SESSION_PREVIEW)
			)
		}
		const [launchLiveLessoResponse] = yield all(launchSessionPreview)
		yield put(onboardingGuideActions.sessionPreviewSuccess(launchLiveLessoResponse, action.presentation_uid))
	} catch (error) {
		const serverError = formatError(error)
		yield put(onboardingGuideActions.sessionPreviewFailed(serverError))
	}
}

export default [
	takeLatest(actionTypes.MY_LIBRARY_INITIALIZE, getOnboardingGuideData),
	takeLatest(actionTypes.ONBOARDING_GUIDE_LAUNCH_TOUR_CARD_SELECTED, completeLaunchTourCard),
	takeLatest(actionTypes.ONBOARDING_GUIDE_EXPLORE_LESSONS_CARD_SELECTED, completeExploreLessonsCard),
	takeLatest(actionTypes.ONBOARDING_GUIDE_LESSON_BUILDER_CARD_SELECTED, completeLessonBuilderCard),
	takeLatest(actionTypes.ONBOARDING_GUIDE_SESSION_PREVIEW_CARD_SELECTED, launchSessionPreview),
	takeLatest(
		actionTypes.NAVIGATION_MENU_HELP_ONBOARDING_GUIDE_SELECTED,
		enableOnboardingGuide
	),
	takeLatest(actionTypes.ONBOARDING_GUIDE_DISMISS_CONFIRMED, dismissOnboardingGuide),
]

export {
	getOnboardingGuideData,
	completeLaunchTourCard,
	completeExploreLessonsCard,
	completeLessonBuilderCard,
	dismissOnboardingGuide,
	launchSessionPreview,
}
